import { useTicketsStore } from "../stores/ticketsStore"

/**
 * Escuta restauração da página pelo cache do navegador (voltar/avançar).
 * Dispara o callback apenas quando a página foi reidratada do histórico (`event.persisted`).
 */
export const registrarEscutaPaginaRestaurada = (fRevalidar) => {
  if (typeof window === "undefined" || typeof fRevalidar !== "function") {
    return () => {}
  }

  const aoRestaurarPagina = (oEvento) => {
    if (oEvento.persisted) {
      fRevalidar()
    }
  }

  window.addEventListener("pageshow", aoRestaurarPagina)
  return () => window.removeEventListener("pageshow", aoRestaurarPagina)
}

/** Revalida tickets de /conversas após restauração da página. */
export const revalidarConversasPaginaRestaurada = () => {
  if (!window.location.pathname.startsWith("/conversas")) return

  const { ticketsInicialBuscar, obterChaveSessaoInicial } = useTicketsStore.getState()

  ticketsInicialBuscar({}, 1, {
    silencioso: true,
    cChaveSessao: obterChaveSessaoInicial(),
  }).catch(() => {})
}
